import { defineStore } from 'pinia';

export const useWorkflowSelection = defineStore('bvWorkflowSelection', {
  state: () => ({
    selectedNodeId: null as string | number | null,
    addClickedNode: null as any, // Will be typed properly when we create the main workflow store
    copiedNode: null as any,
  }),

  actions: {
    selectNode(nodeId: string | number) {
      this.selectedNodeId = nodeId;
    },

    setAddClickedNode(node: any) {
      this.addClickedNode = node;
    },

    clearAddClickedNode() {
      this.addClickedNode = null;
    },

    setCopiedNode(node: any) {
      this.copiedNode = node;
    },

    clearCopiedNode() {
      this.copiedNode = null;
    },

    reset() {
      this.selectedNodeId = '__root__';
      this.addClickedNode = null;
      this.copiedNode = null;
    },
  },
});
